module.exports = __webpack_public_path__ + "static/media/pass-01.1ce57c1d.svg";